import React from "react";
import axios from "axios";
import { Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import GLOBALVAR from "../../constants";
import { format } from 'date-fns';
import LoadingSpinner from "../../components/misc/LoadingSpinner";
import './css/ListPaginationApplicatiion.scss'; 
import ViewportChecker from "./ViewportChecker";

function ListPaginationApplication() {
    const [applicationHeaders, setApplicationHeaders] = useState([]);
    const [applicationLists, setApplicationLists] = useState([]);
    const [showSpinner, setShowSpinner] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [count, setCount] = useState(0);
    const [searchQuery, setSearchQuery] = useState(""); // Add search query state
    const itemsPerPage = 10;
    const isMobile = ViewportChecker();

    const fetchDataApplications = async (currentPage, searchQuery = "") => {
        setShowSpinner(true);

        try {
            let response;
            if (searchQuery) {
                response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/applicationsearch`, {
                    params: {
                        query: searchQuery,
                        page: currentPage,
                        limit: itemsPerPage
                    }
                });
            } else {
                response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/applications/fetch/all?page=${currentPage}&limit=${itemsPerPage}`);
            }

            const appdata = response.data.rows.reduce((acc, item) => {
                acc[item.id] = {
                    items: [
                        { key: 'id', value: item.id },
                        { key: 'fullname', value: `${item.lastName}, ${item.firstName} ${item.middleName}` },
                        { key: 'birthday', value: format(new Date(item.birthday), 'MM/dd/yyyy') },
                        { key: 'mobileno', value: item.mobileNo1 },
                        { key: 'email', value: item.emailAddress },
                        { key: 'address', value: `${item.street} ${item.barangay}, ${item.municipality}, ${item.province} ${item.zipCode}` },
                        { key: 'action', value: item.id }
                    ]
                };
                return acc;
            }, {});

            setCount(response.data.count);
            setApplicationLists(appdata);

            const applicationhead = [
                { value: "ID" },
                { value: "Full Name" },
                { value: "Birthday" },
                { value: "Mobile #" },
                { value: "Email" },
                { value: "Address" },
                { value: "Action" }
            ];

            setApplicationHeaders(applicationhead);
            setShowSpinner(false);
        } catch (error) {
            console.error('Error submitting form:', error);
            setShowSpinner(false);
        }
    };

    const handleSearchChange = (event) => {
        setCurrentPage(1); // Reset to first page on new search
        setSearchQuery(event.target.value);
    };

    const handleSearchSubmit = (event) => {
        event.preventDefault();
        setCurrentPage(1); // Reset to first page on new search
        fetchDataApplications(1, searchQuery);
    };

    const btnPrev = () => {
        setCurrentPage(prevPage => prevPage - 1);
    };

    const btnNext = () => {
        setCurrentPage(prevPage => prevPage + 1);
    };

    const btnPage = (page) => {
        setCurrentPage(page);
    };

    const btnFirst = () => {
        setCurrentPage(1);
    };

    const btnLast = () => {
        const totalPages = Math.ceil(count / itemsPerPage);
        setCurrentPage(totalPages);
    };

    const totalPages = Math.ceil(count / itemsPerPage);

    const getPageNumbers = () => {
        const pageNumbers = [];
        const totalPagesToShow = 3;

        if (totalPages <= totalPagesToShow) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const lastPage = currentPage + 1 > totalPages ? totalPages : currentPage + 1;
            const firstPage = lastPage - (totalPagesToShow - 1) > 0 ? lastPage - (totalPagesToShow - 1) : 1;
            const dots = currentPage + 1 < totalPages ? '...' : '';

            for (let i = firstPage; i <= lastPage; i++) {
                pageNumbers.push(i);
            }

            if (dots) {
                pageNumbers.push(dots);
            }

            pageNumbers.push(totalPages);
        }

        return pageNumbers;
    };

    const focussearch = () => {
        const inputElement = document.querySelector('.search-input-applicant');
        inputElement.focus();
    };

    // eslint-disable-next-line
    useEffect(() => {
        fetchDataApplications(currentPage, searchQuery);
    }, [currentPage, searchQuery]); // Call fetchDataApplications whenever currentPage or searchQuery changes

    return (
        <>
        {showSpinner && (<LoadingSpinner />)}
        <Table className="list-container list-applicants" hover responsive>
            <thead className="list-title">
                <tr>
                    {!isMobile && <td colSpan={5}><h1>Application List</h1></td>}
                    <td colSpan={(isMobile)?3:2}>
                    <form onSubmit={handleSearchSubmit} className="searchform" onClick={focussearch}>
                        <div className="search-icon"><i className="fa-solid fa-magnifying-glass"></i></div>
                        <input
                            type="text"
                            placeholder="Search Applicant"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            className="search-input-applicant"
                        />
                    </form>
                    </td>
                </tr>
                <tr>
                {
                    applicationHeaders.map((item, index) => {
                        return(
                            <th className="list-header-item" key={index}>{item.value}</th>
                        );
                    })
                }
                </tr>
            </thead>
            <tbody>
            {
                Object.values(applicationLists).reverse().map((item, index) => (
                    <tr className="list-body" key={index}>
                        {item.items.map((subitem, subindex) => {
                            let itemval = subitem.value;

                            if (subitem.key === "id") {
                                itemval = <a href={`/applicant/${subitem.value}`}>{subitem.value.toString().padStart(6, '0')}</a>;
                            }

                            if (subitem.key === "action") {
                                itemval = <><a className="btn-action" href={`/applicant/${subitem.value}`}><i className="fa-solid fa-magnifying-glass"></i></a><a className="btn-action" href={`/loan-processing/?id=${subitem.value}`}><i className="fa-solid fa-square-plus"></i></a></>;
                            }

                            return (
                                <td className="list-body-item" key={`${index}+${subindex}`}>
                                    {itemval}
                                </td>
                            );
                        })}
                    </tr>
                ))
            }
            </tbody>
            <tfoot>
                <tr className="page-buttons">
                    <td colSpan="7">
                        <div className="page-buttons__container">
                            <button onClick={btnFirst} disabled={currentPage === 1}>
                                <i className="fa-solid fa-angles-left"></i>
                            </button>
                            <button onClick={btnPrev} disabled={currentPage === 1}>
                                <i className="fa-solid fa-angle-left"></i>
                            </button>
                            {getPageNumbers().map((page, index) => (
                                <React.Fragment key={index}>
                                    {page === '...' ? (
                                        <span className="elip">
                                            <i className="fa-solid fa-ellipsis"></i>
                                        </span>
                                    ) : (
                                        <span className="number">
                                            <button onClick={() => btnPage(page)} disabled={currentPage === page}>
                                                {page}
                                            </button>
                                        </span>
                                    )}
                                </React.Fragment>
                            ))}
                            <button onClick={btnNext} disabled={currentPage === totalPages}>
                                <i className="fa-solid fa-angle-right"></i>
                            </button>
                            <button onClick={btnLast} disabled={currentPage === totalPages}>
                                <i className="fa-solid fa-angles-right"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tfoot>

        </Table>
        </>
    );
}

export default ListPaginationApplication;